import api from '@/axios'
import type { User, Users, UserResponse } from '@/types/user-types'

export const addUsers = async (data: User): Promise<UserResponse> => {
  const response = await api.post('/users', data)
  return response.data
}

export const getUsers = async (): Promise<Users[]> => {
  const response = await api.get('/users')
  return response.data
}

export const editUser = async (id: string, data: User): Promise<void> => {
  const response = await api.patch(`/users/${id}`, data)
  return response.data
}

export const removeUser = async (id: string): Promise<void> => {
  const response = await api.patch(`/users/${id}`)
  return response.data
}

export const getUser = async (id: string): Promise<User> => {
  const response = await api.get(`/users/${id}`)
  return response.data
}